import { render, staticRenderFns } from "./PaymentTariffTypeSelect.vue?vue&type=template&id=606b9ca0&lang=pug"
import script from "./PaymentTariffTypeSelect.vue?vue&type=script&lang=js"
export * from "./PaymentTariffTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports